"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
exports.KushkiGateway = void 0;
/**
 * Kushki Gateway File
 */
/* tslint:disable: no-unnecessary-callback-wrapper */
var axios_1 = require("axios");
var AurusError_1 = require("./../../lib/generic/AurusError");
var EnvironmentEnum_1 = require("./../../lib/infrastructure/EnvironmentEnum");
var PathEnum_1 = require("./../../lib/infrastructure/PathEnum");
var inversify_1 = require("inversify");
require("reflect-metadata");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var UtilsService_1 = require("./../../lib/service/UtilsService");
/**
 * Kushki Gateway Implementation
 */
var KushkiGateway = /** @class */ (function () {
    function KushkiGateway() {
        this._publicHeader = "Public-Merchant-Id";
        this._contentHeader = "Content-Type";
        this._contentJSON = "application/json";
        this._uatUrl = "";
        this._prodUrl = "";
        this._kshAuthorization = "KSH-Authorization";
    }
    KushkiGateway_1 = KushkiGateway;
    KushkiGateway._aurusError = function (data) {
        return data.hasOwnProperty("response_code");
    };
    KushkiGateway.prototype.request = function (body, headers, path, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(this._assignChannel(regional, path)).pipe(operators_1.switchMap(function () {
            var _a;
            return axios_1["default"].post("" + (testEnv ? _this._uatUrl : _this._prodUrl), body, {
                headers: __assign(__assign({}, headers), (_a = {}, _a[_this._contentHeader] = _this._contentJSON, _a))
            });
        }), operators_1.map(function (response) { return response.data; }), operators_1.catchError(function (err) {
            if (KushkiGateway_1._aurusError(UtilsService_1.UtilsService.sGet(err, "response.data", {})))
                throw new AurusError_1.AurusError(UtilsService_1.UtilsService.sGet(err, "response.data.response_code"), UtilsService_1.UtilsService.sGet(err, "response.data.response_text"));
            return rxjs_1.throwError(err);
        }));
    };
    KushkiGateway.prototype.requestGet = function (path, testEnv, regional, mid) {
        var _this = this;
        return rxjs_1.of(this._assignChannel(regional, path)).pipe(operators_1.switchMap(function () {
            var _a;
            return axios_1["default"].get("" + (testEnv ? _this._uatUrl : _this._prodUrl), {
                headers: (_a = {},
                    _a[_this._publicHeader] = mid,
                    _a[_this._contentHeader] = _this._contentJSON,
                    _a)
            });
        }), operators_1.map(function (response) { return response.data; }), operators_1.catchError(function (err) { return rxjs_1.throwError(err); }));
    };
    KushkiGateway.prototype.requestDelete = function (path, testEnv, regional, mid, authorization) {
        var _this = this;
        return rxjs_1.of(this._assignChannel(regional, path)).pipe(operators_1.switchMap(function () {
            var _a;
            return axios_1["default"]["delete"]("" + (testEnv ? _this._uatUrl : _this._prodUrl), {
                headers: (_a = {},
                    _a[_this._contentHeader] = _this._contentJSON,
                    _a[_this._kshAuthorization] = authorization,
                    _a[_this._publicHeader] = mid,
                    _a)
            });
        }), operators_1.map(function (response) { return response.data; }), operators_1.catchError(function (err) { return rxjs_1.throwError(err); }));
    };
    KushkiGateway.prototype.requestBrandsByMerchant = function (mid, testEnv, regional) {
        return this.requestGet("" + PathEnum_1.PathEnum.brands_by_merchant, testEnv, regional, mid);
    };
    KushkiGateway.prototype.requestToken = function (body, mid, testEnv, regional, authorization) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            var _a, _b;
            return rxjs_1.iif(function () { return authorization === undefined; }, _this.request(body, (_a = {},
                _a[_this._publicHeader] = mid,
                _a), PathEnum_1.PathEnum.card_tokens, testEnv, regional), _this.request(body, (_b = {},
                _b[_this._kshAuthorization] = authorization,
                _b[_this._publicHeader] = mid,
                _b), PathEnum_1.PathEnum.card_tokens, testEnv, regional));
        }));
    };
    KushkiGateway.prototype.requestDeviceToken = function (body, mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(body, _this._buildHeader(mid), "" + PathEnum_1.PathEnum.card_token_charge + body.subscriptionId + "/tokens", testEnv, regional);
        }));
    };
    KushkiGateway.prototype.requestSubscriptionToken = function (body, mid, testEnv, regional, authorization) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            var _a, _b;
            return rxjs_1.iif(function () { return authorization === undefined; }, _this.request(body, (_a = {},
                _a[_this._publicHeader] = mid,
                _a), PathEnum_1.PathEnum.card_subscription_tokens, testEnv, regional), _this.request(body, (_b = {},
                _b[_this._kshAuthorization] = authorization,
                _b[_this._publicHeader] = mid,
                _b), PathEnum_1.PathEnum.card_subscription_tokens, testEnv, regional));
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestTransferToken = function (body, mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(body, _this._buildHeader(mid), PathEnum_1.PathEnum.transfer_tokens, testEnv, regional);
        }));
    };
    KushkiGateway.prototype.requestMerchantSettings = function (mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.requestGet(PathEnum_1.PathEnum.merchant_settings + "settings", testEnv, regional, mid);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestPseBankList = function (mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.requestGet(PathEnum_1.PathEnum.bank_list, testEnv, regional, mid);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestDeferredConditions = function (mid, bin, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.requestGet("" + PathEnum_1.PathEnum.deferred_options + bin, testEnv, regional, mid);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestBinInfo = function (mid, bin, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.requestGet("" + PathEnum_1.PathEnum.bin_info + bin, testEnv, regional, mid);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestCashToken = function (body, mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(body, _this._buildHeader(mid), PathEnum_1.PathEnum.cash_tokens, testEnv, regional);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.checkStatus = function (mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.requestGet("" + PathEnum_1.PathEnum.gateway_status, testEnv, regional, mid);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestSecureServiceValidation = function (mid, request, isTest, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(request, _this._buildHeader(mid), "" + PathEnum_1.PathEnum.secure_validation, isTest, regional);
        }));
    };
    KushkiGateway.prototype.requestCardAsyncToken = function (body, mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(body, _this._buildHeader(mid), PathEnum_1.PathEnum.card_async_tokens, testEnv, regional);
        }));
    };
    KushkiGateway.prototype.requestSubscriptionCardAsyncToken = function (body, mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(body, _this._buildHeader(mid), PathEnum_1.PathEnum.subscription_card_async_tokens, testEnv, regional);
        }));
    };
    KushkiGateway.prototype.multiMerchantInfo = function (request, mid, isTest, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(request, _this._buildHeader(mid), "" + PathEnum_1.PathEnum.multi_merchant_commission, isTest, regional);
        }));
    };
    KushkiGateway.prototype.requestPayoutsCashToken = function (body, mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(body, _this._buildHeader(mid), PathEnum_1.PathEnum.payouts_cash_tokens, testEnv, regional);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestPayoutsTransferToken = function (body, mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(body, _this._buildHeader(mid), PathEnum_1.PathEnum.payouts_transfer_tokens, testEnv, regional);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.getCommissionConfiguration = function (request, mid, isTest, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(request, _this._buildHeader(mid), "" + PathEnum_1.PathEnum.commission_configuration, isTest, regional);
        }));
    };
    KushkiGateway.prototype.requestTokenTransferSubscription = function (body, mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.request(body, _this._buildHeader(mid), PathEnum_1.PathEnum.transfer_subscription_tokens, testEnv, regional);
        }));
    };
    KushkiGateway.prototype.requestBankList = function (mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.mergeMap(function () {
            return _this.requestGet(PathEnum_1.PathEnum.bank_list_transfer_subscription, testEnv, regional, mid);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestPayoutsTransferBankList = function (mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.mergeMap(function () {
            return _this.requestGet(PathEnum_1.PathEnum.bank_list_payouts_transfer, testEnv, regional, mid);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.requestMobileProcessorToken = function (body, publicCredential, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.switchMap(function () {
            return _this.request(body, _this._buildHeader(publicCredential), PathEnum_1.PathEnum.mobile_processor_token, testEnv, regional);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.chargeMobileProcessor = function (body, publicCredential, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.switchMap(function () {
            return _this.request(body, _this._buildHeader(publicCredential), PathEnum_1.PathEnum.mobile_processor_charge, testEnv, regional);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.deletePaymentMethod = function (body, testEnv, regional, mid, authorization) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.switchMap(function () {
            return _this.requestDelete(PathEnum_1.PathEnum.kpay_delete_payment_method + "/" + body.walletId, testEnv, regional, mid, authorization);
        }), operators_1.map(function (response) { return !!response; }));
    };
    KushkiGateway.prototype.requestSavedPaymentMethods = function (body, testEnv, regional, mid) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.map(function () {
            var email = body.email, kind = body.kind;
            var kind_path = kind !== undefined ? "?kind=" + kind : "";
            return PathEnum_1.PathEnum.kpay_get_saved_payment_methods + "/" + email + kind_path;
        }), operators_1.concatMap(function (path) {
            return _this.requestGet(path, testEnv, regional, mid);
        }), operators_1.map(function (response) { return response; }));
    };
    KushkiGateway.prototype.cybersourceJwt = function (mid, testEnv, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () {
            return _this.requestGet(PathEnum_1.PathEnum.cybersource_jwt, testEnv, regional, mid);
        }), operators_1.map(function (response) { return response.jwt; }));
    };
    KushkiGateway.prototype._assignChannel = function (regional, path) {
        if (!regional) {
            this._uatUrl = "" + EnvironmentEnum_1.EnvironmentEnum.uat + path;
            this._prodUrl = "" + EnvironmentEnum_1.EnvironmentEnum.prod + path;
        }
        else {
            this._uatUrl = "" + EnvironmentEnum_1.EnvironmentEnum.regionalUat + path;
            this._prodUrl = "" + EnvironmentEnum_1.EnvironmentEnum.regionalProd + path;
        }
        return true;
    };
    KushkiGateway.prototype._buildHeader = function (mid) {
        var _a;
        return _a = {},
            _a[this._publicHeader] = mid,
            _a;
    };
    var KushkiGateway_1;
    KushkiGateway = KushkiGateway_1 = __decorate([
        inversify_1.injectable()
    ], KushkiGateway);
    return KushkiGateway;
}());
exports.KushkiGateway = KushkiGateway;
